import { jsx as t } from "react/jsx-runtime";
import "react";
import { classes as _ } from "./utils/helpers.js";
import './assets/ChoicesItem.css';const c = {
  "custom-select": "_custom-select_1152b_1",
  "custom-select__select": "_custom-select__select_1152b_9",
  "custom-select__selection": "_custom-select__selection_1152b_16",
  "custom-select__selections": "_custom-select__selections_1152b_16",
  "custom-select__selected": "_custom-select__selected_1152b_34",
  "custom-select__remove": "_custom-select__remove_1152b_44",
  "custom-select__choices-wrapper": "_custom-select__choices-wrapper_1152b_61",
  "custom-select__choices": "_custom-select__choices_1152b_61",
  "custom-select__choices-wrapper--hidden": "_custom-select__choices-wrapper--hidden_1152b_98",
  "custom-select__icon": "_custom-select__icon_1152b_102",
  "custom-select__icon--chevron": "_custom-select__icon--chevron_1152b_115",
  "custom-select__item--selected": "_custom-select__item--selected_1152b_123",
  "custom-select__item--highlighted": "_custom-select__item--highlighted_1152b_128",
  "custom-select__select--touched": "_custom-select__select--touched_1152b_131"
};
function i({ item: e, handleOnClick: s }) {
  return /* @__PURE__ */ t(
    "li",
    {
      onClick: () => s(e.id),
      id: e.id,
      className: _([
        e.status === "selected" ? `${c["custom-select__item--selected"]} custom-select__item--selected` : "",
        e.status === "highlighted" ? `${c["custom-select__item--highlighted"]} custom-select__item--highlighted` : ""
      ]),
      children: e.label
    },
    e.id
  );
}
export {
  i as C,
  c as s
};
